<template>
<div>
  <v-row>
      <v-col>
        <v-container pb-4 grid-list-xl>
          <v-layout row wrap class="user-detailboxmain fixed-depositbox">
            <v-flex class="user-detailbox">
              <v-list-item v-for="reccuringDetails in savingAccountData" :key="reccuringDetails.id">
                <v-list-item-content>
                  <v-list-item-title>
                    <h3 v-if="reccuringDetails.name">{{reccuringDetails.name}}</h3>
                    <h3 v-else>Account owner name is unavailable</h3> 
                  </v-list-item-title>
                  <v-list-item-subtitle v-for="savingAccountDatas in reccuringDetails.description" :key="savingAccountDatas.id">
                    <div class="account-detailbox">
                        <div class="bank-name">
                          <h5 v-if="savingAccountDatas.company_name">{{savingAccountDatas.company_name}}</h5>
                          <h5 v-else>Company name is unavailable</h5>
                          <p v-if="savingAccountDatas.account_no">{{savingAccountDatas.account_no}}</p>
                          <p v-else>Account number is unavailable</p>
                        </div>
                        <div class="amount-box">
                          <v-col class="memberbox-editbox">
                            <v-menu bottom left offset-y>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  outlined fab
                                  color="#F19700"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="showHide(savingAccountDatas['form_id'])"
                                  v-if="allow_user_activity =='yes'"
                                >
                                  <v-img max-height="20" max-width="20" :src="three_dots" :lazy-src="three_dots"></v-img>
                                </v-btn>
                              </template>
                              <v-list v-if="(hideShowId == savingAccountDatas['form_id'])">
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="editAccounts(savingAccountDatas['form_id'])">
                                      <v-img
                                      max-height="20"
                                      max-width="20"
                                      :src="edit_pic"
                                      :lazy-src="edit_pic"
                                      ></v-img> Edit
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="deleteAccounts(savingAccountDatas['form_id'])">
                                      <v-img
                                      max-height="23"
                                      max-width="19"
                                      :src=" delete_pic"
                                      :lazy-src=" delete_pic"
                                      > </v-img>Delete
                                    </v-btn>
                                  </v-list-item-title>
                                </v-list-item>
                                  <v-list-item>
                                  <v-list-item-title>
                                    <v-btn @click="updateBalance(savingAccountDatas)">
                                      <v-img
                                      max-height="23"
                                      max-width="19"
                                      :src=" update_pic"
                                      :lazy-src=" update_pic"
                                      > </v-img>Update Current Value
                                    </v-btn>
                                    </v-list-item-title>
                                  </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-col>
                          <span>Total Contribution</span>
                          <p><span> &#8377;</span> {{savingAccountDatas.total_contribution}}</p>
                        </div>
                    </div>
                    <div class="maturity-Datebox">
                        <div class="bank-name">
                          <span>Start Date</span>
                          <p v-if="savingAccountDatas.start_date">{{savingAccountDatas.start_date}}</p>
                          <p v-else>Start Date is unavilable</p>
                        </div>
                        <div class="amount-box">
                          <span>EPF balance on {{savingAccountDatas.current_value_date}}</span>
                          <p><span> &#8377;</span> {{savingAccountDatas.account_balance}} </p>
                        </div>
                    </div>
                    <div class="maturity-Datebox Rate-of-Interest">
                        <div class="amount-box">
                        </div>
                        <div class="amount-box">
                          <span>Monthly Contribution</span>
                          <p><span> &#8377;</span> {{savingAccountDatas.monthly_contribution}} </p>
                        </div>
                    </div>
                    <div class="maturity-Datebox">
                      <div class="bank-name">
                        <span>Nominees</span>
                        <p v-if="savingAccountDatas.nominee && savingAccountDatas.nominee.length != 0">
                          <span v-for="(items,index) in savingAccountDatas.nominee">{{items}}<span v-if="savingAccountDatas.nominee.length > index+1">, </span></span>
                        </p>
                        <p v-else>N/A</p>
                      </div>
                      <div class="amount-box"  v-if="savingAccountDatas.total_pension_contribution">
                        <span>Total Pension Contribution</span>
                        <!-- <p><span> &#8377;</span> {{savingAccountDatas.total_pension_contribution}} </p> -->
                        <p><span> &#8377;</span> {{savingAccountDatas.total_pension_contribution}} </p>
                      </div>
                      <div class="" v-if="savingAccountDatas.is_matured == 'MATURED'">
                        <span style="color:#FF0000;"><b>{{savingAccountDatas.is_matured}}</b></span>
                      </div>
                    </div>
                  </v-list-item-subtitle> 
                  
                </v-list-item-content>  
              </v-list-item>
            </v-flex>
          </v-layout>  
        </v-container>  
      <div class="total-amount-box" v-if="savingAccountData.length != 0">
          <h4>Total EPF Balance</h4>
          <div class="total-amount">
            <span>As on {{currentDate | moment("DD MMM, Y")}}</span>
            <p><span> &#8377;</span> {{amount}}</p>
          </div>
      </div>
      <div v-else>
        <v-list-item>
          <div class="user-detailbox">
            <v-list-item-content>
              <div class="text-h5 mb-1">
                No data found.
              </div>
            </v-list-item-content>
          </div>
        </v-list-item>
      </div>
      </v-col>
  </v-row>
  <modal class="common-modal-box sukanya-modal-box my-custom-modal" name="update-balance"> 
    <span class="close"> 
      <v-img width="20" height="20" @click="close" style="float: right;" :src="require('@/assets/images/cross.png')">
      </v-img>
    </span>
    <v-form ref="update" lazy-validation>
        <v-text-field
          v-model="totalContribution"
          value=""
          :rules="[(v) => !!v || 'Field is required']"
          placeholder="Enter Total Contribution"
          class="balance-field"
        >
        </v-text-field>
        <v-text-field
          v-model="update_balance"
          value=""
          :rules="[(v) => !!v || 'Field is required']"
          placeholder="Enter Current Balance"
          class="balance-field"
        >
        </v-text-field>
        <a  href="javascript:void(0)"
          v-on:click="getAccountHelpDetail()">GET HELP ?</a>
        <v-btn class="update-btn" @click="updateEPFBalance">Update Balance</v-btn>
    </v-form>
  </modal>
   <v-dialog v-model="account_help_dialog" persistent  width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            How to know your Account Balance
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col>
                       
              </v-col>  
            </v-row> 
            <div class="custom-notiBox">
              <v-layout class="notificationbox">
                <div class="noti-box inner-notificationbox">
                  <v-card class="imagebox">
                    <div class="noti-innerBox" v-if="this.missed_call_no_array != ''">
                      <h4 style="padding-top:10px !important">Give missed call to {{this.missed_call_no_array.missed_call_no}} from your registered mobile no.</h4>
                      <v-img max-height="25" max-width="25" :src="phone_icon" :lazy-src="phone_icon"></v-img>
                    </div>

                    <div class="noti-innerBox" v-if="this.sms_array != ''">
                      <h4 style="padding-top:10px !important">Send SMS ({{this.sms_array.sms_str}}) to {{this.sms_array.sms_no}}</h4>
                      <v-img max-height="25" max-width="25" :src="sms_icon" :lazy-src="sms_icon"></v-img>
                    </div>

                    <div class="noti-innerBox">
                      <h4 style="padding-top:10px !important">Note: Please ensure that you have registered this mobile no. with your bank for availing missed call service/send SMS</h4>
                    </div>
                  </v-card> 
                </div>
              </v-layout>
            </div>   
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="account_help_dialog = false"
            >
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
    </v-dialog>
</div>
</template>
<script>
import { Auth } from "aws-amplify";
  import { POST_API, GET_API, DELETE_FORM, GET_RETIREMENT_FORM_DETAIL } from "../../../../store/actions.type";
  import ApiService from "../../../../api/api.service";
  import JwtService from "../../.././common/jwt.service";
  import { isEmpty } from 'lodash';
  import axios from "axios";
  export default {
    data () {
      return {
       three_dots:process.env.VUE_APP_ROOT_ICONS_URL + 'three_dots.png',
       currentDate: new Date().setDate(new Date().getDate()),
       // amount:0,
       // savingAccountData:'',
      edit_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'edit.png',
      delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete.png',
      update_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'update.png',
      hideShow:false,
      hideShowId:'',
      update_balance:'',
      totalContribution:'',
      full_name:'',
      account_help_dialog: false,
      sms_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'sms_icon.png',
      whatsapp_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'whatsapp_icon.png',
      phone_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'phone_icon.png',
      getFormData:'',
      account_help_array:[],
      missed_call_no_array:"",
      sms_array:"",
      whatsapp_no_array:"",
      allow_user_activity:localStorage.getItem('allow_user_activity')
      }
    },
    created(){
      Fire.$on("loadData", () => {
        this.savingAccountList();
      });
    },
    mounted () {
      if(this.isDataEmpty ) this.savingAccountList();
    },
    computed: {
      
      isDataEmpty: function () {
        return isEmpty(this.$store.getters.getRetirementFormDetail);
      },
      savingAccountData: function () {
        return !this.isDataEmpty ? this.$store.getters.getRetirementFormDetail.data.epf_detail : [];
      },
      amount: function () {
        let amount = 0;
        this.savingAccountData.forEach(details => {
            details.description.forEach(total => {
              amount +=  parseInt(total.account_balance);
            })
          })
        return amount;
      }
    },
    methods:{
     showHide(id){
        this.hideShowId = id;
        this.hideShow = this.hideShow ? false : true;
      },
      showHideAgain(id){
        if (this.hideShow == true) {
          //this.hideShow = false; 
        }
          //this.hideShow = true;
      },
      close(){
        this.$modal.hide("update-balance");
      },
       updateBalance(savingData){
        this.$modal.show("update-balance");
        this.bank_id = savingData.bank_id;
        this.account_type = savingData.account_type;
        this.account_no = savingData.account_no;
        this.form_id = savingData.form_id;

      },
      updateEPFBalance(){
          if(this.$refs.update.validate()){
            let formdata = new FormData();
            formdata.append(
              "aws_cognito_id",
              atob(localStorage.getItem("cognito_idp"))
            );
            formdata.append("form_id", this.form_id);
            formdata.append("total_contribution",this.totalContribution);
            formdata.append("balance",this.update_balance);
            formdata.append("module_type", 'epf');
            axios
              .post(
                process.env.VUE_APP_ROOT_API + "update-balance",
                formdata
              )
              .then((res) => {
                this.$modal.hide("update-balance");
                swal.fire({
                  title:"Balance Updated Successfully",
                  icon:'success'
                })
                this.savingAccountList();
              })
              .catch(() => {});
        }
      },
      editAccounts(editId){
        this.$router.push({ path: "/edit-employee-provident-fund/"+btoa(editId) }).catch(()=>{});
      },
      deleteAccounts(id){
          swal
        .fire({
          title: "Are you sure, you want to delete this data?",
          showCancelButton: true,
          confirmButtonColor: `#051d42`,
          confirmButtonText: `YES`,
          cancelButtonColor: `#f19700`,
        })
        .then(result => {
          if (result.isConfirmed) {
            let cognito_idp     = atob(localStorage.getItem('cognito_idp'));
            let api_token   = localStorage.getItem("api_token");
            this.$store.dispatch(DELETE_FORM, {
              data: {
                aws_cognito_id: cognito_idp,
                form_id:id,
              },
              api: "delete-form",
            })
            .then(() => {
              this.savingAccountList();
              // Fire.$emit('DeleteepfProvidentFund');
              Toast.fire({
                    icon: 'success',
                    title: 'Data deleted successfully.'
              })
            });

          } else if (result.isDenied) {
            Swal.fire("Changes are not saved", "", "info");
          }
        });
      },
      savingAccountList(){
        this.$loading(true);
        let cognito_idp = atob(localStorage.getItem('cognito_idp'));
        let user_name = this.$store.getters.getUserDetails.user_name;
        let selected_value = this.$store.getters.getUserDetails.selected_value;
        this.$store.dispatch(GET_RETIREMENT_FORM_DETAIL, {
          data: {
            aws_cognito_id: cognito_idp,
            aws_cognito_id: cognito_idp,
            user_name:user_name,
            member_id:selected_value,
          },
          api: "get-retirement-form-detail",
        })
        .then(() => {
          Fire.$emit('retirementGraphData');
          this.$loading(false);
        }).catch(() => {
          this.$loading(false);
        });
      },
      getAccountHelpDetail(){
      if(this.account_no == ''){
        swal.fire({title:"Please enter UAN"});
      }
      else{
        let formdata    = new FormData();
        formdata.append("aws_cognito_id", atob(localStorage.getItem('cognito_idp')));
        formdata.append("uin", this.account_no);
        axios.post( process.env.VUE_APP_ROOT_API+'get-epfo-help-detail', formdata).then((res) => {
          console.log(res.data.data.sms_array)
          this.missed_call_no_array = res.data.data.missed_call_no_array
          this.sms_array = res.data.data.sms_array
          this.whatsapp_no_array = res.data.data.whatsapp_no_array
          setTimeout(()=>{
            this.$modal.hide("update-balance");
            this.account_help_dialog = true
            }, 500)
      }).catch(() => {})
        }
    }
    }
  }
</script>
